import * as React from "react";
const SvgMapPin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#map-pin_svg__a)"
    >
      <path d="M13.667 6.333c0 3.329-3.693 6.796-4.933 7.866a.67.67 0 0 1-.801 0C6.693 13.13 3 9.662 3 6.333a5.333 5.333 0 1 1 10.667 0" />
      <path d="M8.333 8.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    </g>
    <defs>
      <clipPath id="map-pin_svg__a">
        <path fill="#fff" d="M0 0h16.667v15.333H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMapPin;
